import {
    useQuery,
    UseQueryOptions,
    QueryKey,
    QueryFunctionContext,
} from '@tanstack/react-query';

/**
 * A reusable wrapper around TanStack's useQuery.
 * @param queryKey The key for the query.
 * @param queryFn The async function to fetch data. Receives the React Query
 *   context, so callers can forward `context.signal` to axios and have
 *   superseded requests aborted automatically.
 * @param options Other useQuery options (e.g., select, enabled, staleTime).
 */
export const useApiQuery = <
    TQueryFnData = unknown,
    TError = Error,
    TData = TQueryFnData
>(
    queryKey: QueryKey,
    queryFn: (context: QueryFunctionContext) => Promise<TQueryFnData>,
    options?: Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        queryKey,
        queryFn,
        retry: 2,
        staleTime: 5 * 60 * 1000, // 5 minutes default stale time
        ...options,
    });
};